import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { WorktypeLegend } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerOption/WorktypeLegend';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

export const WorktypeAnalysisControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { getClientTerm } = useClientTerminology();

  const isActive = layerConfig[LayerType.worktype_analysis].visible;

  const toggleWorktypeAnalysisLayer = (v: boolean) => {
    TagManager.dataLayer({
      dataLayer: {
        event: v
          ? GoogleEvents.worktypeAnalysisOn
          : GoogleEvents.worktypeAnalysisOff,
      },
    });
    return dispatch(
      updateMapLayerConfig({
        [LayerType.worktype_analysis]: { visible: v },
      })
    );
  };

  const isSmallScreen = useSmallScreen();

  return (
    <>
      <MapLayerGroupControl
        title={getClientTerm('map.layerManager.worktypeAnalysisTitle')}
        onVisibilityChange={toggleWorktypeAnalysisLayer}
        isGroupVisible={isActive}
        data-testid="worktype-analysis-control"
      />
      {isSmallScreen && <WorktypeLegend />}
    </>
  );
};
